import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import {
  insertar_generacion_cuenta,
  insertar_modalidad_pago,
} from "../services/Pagos";
import { update_paso } from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalConfirmacionModalidad = () => {
  let {
    obtenerDatosEstudiante,
  } = useMatricula();
  let {
    setPasoSegundaVistaProcesoM,
    stCuotaSelecionada,
    setLoading,
    resumenPagoEstudiante,
    setPasoProcesoM,
    setErrorCursoServices
  } = useProcesoMatricula();
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});



  const validarBtnPago = async () => {

    if (stCuotaSelecionada !== "") {
      try {
        setLoading(true);
        let generacionCuenta = await insertar_generacion_cuenta(
          obtenerDatosEstudiante,
          { stCuotaSelecionada }
        );

        if (
          generacionCuenta.StatusCode == 200 &&
          generacionCuenta.Data.respuesta == 1
        ) {
          let modalidadPago = await insertar_modalidad_pago(
            obtenerDatosEstudiante,
            { stCuotaSelecionada },
            resumenPagoEstudiante
          );

          if (
            modalidadPago.StatusCode == 200 &&
            modalidadPago.Data.respuesta == 1
          ) {
            let pasosOk = await update_paso(obtenerDatosEstudiante, 4, 2);

            if (pasosOk.StatusCode == 200 && pasosOk.Code == 1) {
              let convertirPasoCompletadoMayoCero = Number(
                pasosOk.Data.paso_siguiente
              );

              let convertirPasoCompletado =
                convertirPasoCompletadoMayoCero > 0
                  ? convertirPasoCompletadoMayoCero - 1
                  : convertirPasoCompletadoMayoCero;


              let vistapago_siguientes = Number(
                pasosOk.Data.vistapago_siguiente
              );

              let convertirSegundoPaso =
                vistapago_siguientes == 1 ? false : true;


              setPasoProcesoM(convertirPasoCompletado);
              setPasoSegundaVistaProcesoM(convertirSegundoPaso);


            } else {
              throw pasosOk.Message
            }
          }
          else {
            throw modalidadPago.Message
          }
        }
        else {
          throw generacionCuenta.Message
        }


      } catch (error) {
        setLoading(false);
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();

          setErrorCursoServices(error)
        }
      } finally {
        setLoading(false);
      }
    }

  };

  useEffect(() => {

    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        msj_desea_continuar: obtenerLabelEtiqueta(
          "lbl_pago_msj_desea_continuar",
          listadoEtiquetas
        ),
        pago_msj_escogida: obtenerLabelEtiqueta(
          "lbl_pago_msj_escogida",
          listadoEtiquetas
        ),
        sumilla_aceptar: obtenerLabelEtiqueta(
          "lbl_sumilla_aceptar",
          listadoEtiquetas
        ),
        lbl_pago_msj_seleccione_continuar: obtenerLabelEtiqueta(
          "lbl_pago_msj_seleccione_continuar",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    msj_desea_continuar,
    pago_msj_escogida,
    sumilla_aceptar,
    lbl_pago_msj_seleccione_continuar,
  } = etiquetas;

  return (
    <div
      className="modal fade"
      id="modalidad"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0">
            <h5 className="modal-title" id="exampleModalLabel1"></h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <h5 className="text-uppercase ">
                {stCuotaSelecionada !== ""
                  ? msj_desea_continuar
                  : lbl_pago_msj_seleccione_continuar}
              </h5>
              <p>{stCuotaSelecionada !== "" ? pago_msj_escogida : ""}</p>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={validarBtnPago}
            >
              {sumilla_aceptar}
            </button>
          </div>
        </div>
      </div>
      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      ></button>
    </div>
  );
};

export default ModalConfirmacionModalidad;
